"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var scroll_1 = require("../helpers/scroll");
var main_1 = require("../main");
var bootstrap_1 = require("bootstrap");
var ContactButtonScroll = /** @class */ (function () {
    function ContactButtonScroll() {
        this.triggers = document.querySelectorAll("[".concat(constants_1.DATA_CONTACT_BUTTON, "]"));
        this.navbarElement = document.getElementById('navbarNav');
        if (this.triggers.length <= 0) {
            return;
        }
        this.collapsableNav = new bootstrap_1.Collapse(this.navbarElement, {
            toggle: false,
        });
        // Detect last child of main with an id starting with "c"
        var container = document.querySelector('main');
        // Get all child elements within main
        var elements = container.getElementsByTagName('*');
        // Initialize variable to store the last element with id starting with 'c'
        var lastElementWithCId = null;
        // Loop through elements to find the last one with id starting with 'c'
        for (var i = 0; i < elements.length; i++) {
            if (elements[i].id.startsWith('c')) {
                lastElementWithCId = elements[i];
            }
        }
        // Assign last element to target variable
        this.target = lastElementWithCId;
        this.scrollToTransition();
    }
    // This function scrolls to last element with an id that starts with "c" and closes the opened menu
    ContactButtonScroll.prototype.scrollToTransition = function () {
        var _this = this;
        this.triggers.forEach(function (element) {
            element.addEventListener('click', function () {
                (0, scroll_1.scrollToDomElement)(_this.target);
                if (_this.navbarElement.classList.contains('show')) {
                    _this.collapsableNav.hide();
                    main_1.navbarMain.resetAdjustments();
                }
            });
        });
    };
    return ContactButtonScroll;
}());
exports.default = ContactButtonScroll;
